import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { css, px } from '@jd/jmtd-tools/es/css';
import ResizeObserver from 'resize-observer-polyfill';

var Collapse = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  var _super = _createSuper(Collapse);

  function Collapse() {
    _classCallCheck(this, Collapse);

    return _super.apply(this, arguments);
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var ro = this.ro = new ResizeObserver(function () {
        _this.updateSize();
      });
      ro.observe(this.contentRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateSize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ro && this.ro.disconnect();
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this$props = this.props,
          open = _this$props.open,
          collapsedHeight = _this$props.collapsedHeight,
          ref = this.ref,
          contentRef = this.contentRef;
      css(ref, 'height', px(open ? contentRef.offsetHeight : collapsedHeight));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          className = _this$props2.className,
          open = _this$props2.open,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: classNames('jmtd-collapse', className, {
          'jmtd-collapse-open': open
        }),
        ref: function ref(el) {
          _this2.ref = el;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-collapse-content",
        ref: function ref(el) {
          _this2.contentRef = el;
        }
      }, children));
    }
  }]);

  return Collapse;
}(React.PureComponent);

Collapse.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  open: PropTypes.bool,
  collapsedHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Collapse.defaultProps = {
  id: null,
  children: null,
  className: '',
  open: false,
  collapsedHeight: 0
};
export default Collapse;